import * as I18n from 'i18n-js';
import * as React from 'react';

interface IProps extends React.HTMLProps<HTMLElement> {
  html?: boolean;
  to?: string;
  text: string;
  args?: { [key: string]: string };
  tag?: string;
  children?: React.ReactNode;
}

/**
 * Returns a span tag with the contents set to the value of
 * the given i18n key. Optionally can be flagged as html
 * safe.
 *
 * WARNING!!! Do not use this with user provided
 * input unless first sanitizing it (see <SanitizedRender />)
 *
 * Example:
 *
 * import { I18N } from './translate';
 *
 * <I18N
 *  html
 *  tag="p"
 *  text="js.some.key"
 *  args={{ foo: 'bar' }}
 * />
 *
 * You can also pass in children for richer translation components, this
 * is preferable to passing in strings as html elements and gets you
 * sanitization via React!
 *
 * You translation key needs to have {{children}} as placeholder
 *
 * <I18N tag="p" text="js.some.key">
 *   <CoreLink to="/foozles"><I18N text="js.another.key" /></CoreLink>
 * </I18N>
 */
export function I18N(props: IProps) {
  const { children, text, args, tag, html, ...htmlProps } = props;
  const el = tag || 'span';

  if (children) {
    const str = I18n.t(text, { ...args, children: '_PLACE' });
    const parts = str.split('_PLACE');
    if (parts.length !== 2) {
      console.error('when using children, ensure that you have one {{children}} placeholder');
    }

    return React.createElement(el, { ...htmlProps }, [parts[0], children, parts[1]]);
  }

  if (html) {
    return React.createElement(el, {
      ...htmlProps,
      dangerouslySetInnerHTML: {
        __html: I18n.t(text, args),
      } },
    );
  }

  return React.createElement(
    el,
    { ...htmlProps },
    I18n.t(text, args),
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/translate.tsx